import { createContext, RefObject, useContext, useRef } from 'react';

import { CustomFormSidebarRenderRef } from 'ev-common/Sidebar/CustomForms/CustomForms';

export const CustomFormsContext = createContext({
  formRef: {
    current: null,
  } as RefObject<CustomFormSidebarRenderRef>,
});

export const CustomFormsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const formRef = useRef<CustomFormSidebarRenderRef>(null);

  return (
    <CustomFormsContext.Provider value={{ formRef }}>
      {children}
    </CustomFormsContext.Provider>
  );
};

export default function useCustomFormRef() {
  const { formRef } = useContext(CustomFormsContext);
  return { formRef };
}
